import { Plus } from 'lucide-react';
import React from 'react';
import NewPubForm from './NewPubForm';
import { Button, FormDrawer } from '../ui';

export default function NewPub(props: { handleFunction: any, services: any }) {
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Button
                size='sm'
                className="float-right"
                variant="primary"
                startIcon={<Plus size={16} />}
                onClick={() => setOpen(true)}
            >Ajouter</Button>
            <FormDrawer
                open={open}
                onClose={handleClose}
                title="Nouvelle publicité"
                hint="Renseignez les informations de la publicité et joignez le média à diffuser."
            >
                <NewPubForm handleFunction={props.handleFunction} pub={props.services} />
            </FormDrawer>
        </div>
    );
}
